import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-modal-success-message',
  templateUrl: './modal-success-message.component.html',
  styleUrls: ['./modal-success-message.component.css']
})
export class ModalSuccessMessageComponent implements OnInit {
  @Input() message: string;
  @Output() show: EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor() {}

  ngOnInit() {}

  closeModal() {
    this.show.emit(false);
  }

  // todo next: dismiss modal stlh 3 detik
}



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/_shared/layout/modal-success-message/modal-success-message.component.ts